import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "path-container" }
const _hoisted_3 = { class: "path-item path-item-applicant" }
const _hoisted_4 = { class: "path-item__content text-center" }
const _hoisted_5 = { class: "d-flex justify-content-center align-items-stretch align-self-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Welcome! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("New Applicants/Users")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-pen" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  Register ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("   Search for Scholarships ")
const _hoisted_12 = { class: "path-item path-item-login" }
const _hoisted_13 = { class: "path-item__content" }
const _hoisted_14 = {
  key: 0,
  class: "text-center fw-bold mb-4"
}
const _hoisted_15 = {
  key: 1,
  class: "text-center"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  "asp-validation-summary": "All",
  class: "text-danger fw-bold"
}, null, -1)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "Username",
  class: "form-label"
}, "Email Address", -1)
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "Password",
  class: "form-label"
}, "Password", -1)
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-sign-in-alt" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("  Login ")
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Forgot Email or Password?")
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Contact Support")
const _hoisted_28 = {
  key: 2,
  class: "alert alert-danger mt-3 rounded"
}
const _hoisted_29 = { class: "text-danger" }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Or ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("click here")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" to start a new application")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_activity_button = _resolveComponent("activity-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createVNode(_component_router_link, {
                  to: { name: 'Public/Register' },
                  class: "btn btn-lg btn-outline-primary mb-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _hoisted_9,
                (!_ctx.applicationInProgress)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { name: 'Public/Search/Home' },
                      class: "btn btn-lg btn-outline-primary mb-2"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _hoisted_11
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_ctx.applicationInProgress)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_14, "You must Login or Register to complete your application"))
              : (_openBlock(), _createElementBlock("h2", _hoisted_15, "Returning Users")),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.model.username = $event)),
                type: "email",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.model.username]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model.password = $event)),
                type: "password",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.model.password]
              ])
            ]),
            _createElementVNode("p", _hoisted_21, [
              _createVNode(_component_activity_button, {
                disabled: !_ctx.canLogin,
                class: _normalizeClass([{ 'btn-disabled': !_ctx.canLogin }, "btn btn-lg btn-primary mb-2"]),
                type: "submit",
                clickHandler: _ctx.onLogin,
                "continue-loading-on-success": _ctx.model.continueLoadingOnSuccess
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["disabled", "class", "clickHandler", "continue-loading-on-success"])
            ]),
            _createElementVNode("p", _hoisted_24, [
              _createVNode(_component_router_link, { to: { name: 'Public/Login/Help' } }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", _hoisted_26, [
              _createVNode(_component_router_link, { to: "Public/Support" }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              })
            ]),
            (_ctx.errorMessage?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.errorMessage), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.applicationInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("span", null, [
                    _hoisted_31,
                    _createVNode(_component_router_link, { to: { name: 'Public/Search/Home' } }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    }),
                    _hoisted_33
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}